import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import {TranslateModule} from "@ngx-translate/core";
import { AuthService } from './service/auth.service';
import { IdleService } from './service/idle.service';
import { GlobalSpinnerComponent } from './shared/global-spinner.component';
import { TopNavbarComponent } from './core/top-navbar/top-navbar.component';

/**
 * Glavna komponenta aplikacije (root komponenta).
 * 
 * - selector: 'app-root' - početna točka aplikacije
 * - imports: RouterOutlet - omogućuje prikaz child komponenti prema rutama
 * - templateUrl: putanja do HTML predloška
 * - styleUrl: putanja do CSS datoteke
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, TranslateModule, GlobalSpinnerComponent, TopNavbarComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements OnInit {

  /**
   * Naslov aplikacije.
   */
  title = 'Mapsy';

  constructor(private authService: AuthService, private idleService: IdleService, private router: Router) {}

  get showNavbar(): boolean {
    return !this.router.url.startsWith('/login') && !this.router.url.startsWith('/test-zona/cloudLogin');
  }

  ngOnInit(): void {
    // startup refresh is handled by APP_INITIALIZER in app.config.ts. We keep the
    // currentUser subscription below to start/stop the idle watcher when auth state changes.

    // subscribe to auth state and start/stop idle watcher
    this.authService.currentUser.subscribe(user => {
      if (user) {
        this.idleService.startWatching();
      } else {
        this.idleService.stopWatching();
      }
    });
  }
}
